import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../modules';
import { editContent, saveContentsAsync } from "../../modules/editor";

import FieldSection from './FieldSection';
import ToggleField from '../../components/Dropdown/ToggleFieldSet';

import CheckIcon from '../../components/Icon/CheckIcon';

import newWindowIcon from '../../assets/images/icon/newWindow.png';

import { createQuery } from '../../util/object';

type Props = {
	target: string
	domain: string
	products: any[]
	value: string
};

function SelectedContentDonationProduct({ target, domain, products, value }: Props) {
	const dispatch = useDispatch();
	
	const [params, setParams] = useState({
		dontype: '',
		period: 'pledge',
		price: '',
		fixprice: 'N',
		background: '',
		email: '',
		name: '',
		contributor: '',
		promisememo: '',
		stb_value: '$%stb_value%$',
		method: 'step1',
		parameters: ''
	} as any);

	useEffect(() => {
		if (params.dontype.length === 0 && params.price.length === 0) {
			return;
		}
		
		updateLink();
	}, [params]);

	useEffect(() => {		
		if (value.length === 0 || domain.length === 0) {
			return;
		}

		const defaultParamsKeys = [ 'dontype', 'period', 'price', 'fixprice', 'background', 'email', 'name', 'contributor', 'promisememo', 'stb_value', 'method', 'parameters']

		let nextParams:any = {}
		const suffix = value.split('stb_value=$%stb_value%$&')[1]

		value.split('?')[1].split('&').map((item:string) => {
			let key = item.split('=')[0];
			let value = item.split('=')[1];

			//설정 키 이외의 값이 들어가는 것 방지, parameter값이 키로 생성되어 undefined로 들어가는 것 방지
			if(!defaultParamsKeys.includes(key)) return null;
      if(value === 'undefined'||value===undefined) return null;

			nextParams[key] = value;
		});

		nextParams['parameters'] = suffix
		
		setParams({
			...params,
			...nextParams
		});
	}, [domain.length, target]);

	useEffect(() => {
		if (products.length === 0) {
			return;
		}
		
		if (!value.includes('dontype')) {
			setParams({
				...params,
				...{dontype: products[0].productCode}
			})
		}		
	}, [products])
	
	const updateLink = () => {
		const nextLink = `${domain}${params.method}?${createQuery(params, 'method, parameters', params.parameters)}`;
		dispatch(editContent({ target: `${target}/buttonLink`, data: nextLink }));
		dispatch(saveContentsAsync.request());
	}

	const paramsValue = (target: string, value: string) => {
		switch (target) {
			case 'method':
				return params[target] === 'step1' ? 'step1_direct' : 'step1';

			case 'fixprice':
				return params[target] === 'Y' ? 'N' : 'Y';

			case 'email':
				return params[target] === '$%_email%$' ? '' : '$%_email%$';

			case 'name':
				return params[target] === '$%name%$' ? '' : '$%name%$';

			default:
				return value;
		}
	}

	const onToggleParam = (target: string, value: string) => {
		setParams({
			...params,
			[target]: paramsValue(target, value)
		});
	}

	const onChangeParam = (e: any, target: string) => {
		const { value } = e.target;
		setParams({
			...params,
			[target]: value
		});
	}

	return (
		<>
			<FieldSection
				labelName="모금 상품"
				labelSize=""
				fullWidth={true}
			>
				<select
					className="select full"
					value={params?.dontype}
					onChange={(e) => onChangeParam(e, 'dontype')}
				>
					{
						products.map((item:any, index:number) => (
							<option key={index} value={item.productCode}>{item.productName}</option>
						))
					}
				</select>
			</FieldSection>
			<FieldSection
				labelName=""
				label={false}
				fullWidth={true}
			>
				<div className="field-type-toggle">
					<button onClick={() => onToggleParam('method', 'Y')}>
						<CheckIcon checked={params.method === 'step1'} />
						모금 상품 변경 허용하기
					</button>
				</div>
			</FieldSection>
			<FieldSection
				labelName="후원주기"
				labelSize=""
				fullWidth={true}
			>
				<div className="layout-field">
					<button className={params.period === 'pledge' ? 'btn medium primary-black' : 'btn medium line tertiary'} onClick={() => {onChangeParam({target:{value:'pledge'}}, 'period')}}>정기후원</button>
					<button className={params.period === 'oneoff' ? 'btn medium primary-black' : 'btn medium line tertiary'} onClick={() => {onChangeParam({target:{value:'oneoff'}}, 'period')}}>일시후원</button>
				</div>
			</FieldSection>
			<FieldSection
				labelName="기부금액"
				labelSize=""
				fullWidth={true}
			>
				<input
					type="text"
					placeholder="예. 20000"
					value={params.price}
					onChange={(e) => onChangeParam(e, 'price')}
				/>
			</FieldSection>
			<FieldSection
				labelName=""
				label={false}
				fullWidth={true}
			>
				<div className="field-type-toggle">
					<button onClick={() => onToggleParam('fixprice', 'Y')}>
						<CheckIcon checked={params.fixprice === 'Y'} />
						기부금액 변경 허용하기
					</button>
				</div>
			</FieldSection>
			<h4 className="field-section-sub-title">후원자 정보</h4>
			<FieldSection
				labelName=""
				label={false}
				fullWidth={true}
			>
				<div className="field-type-toggle">
					<button onClick={() => onToggleParam('email', '$%_email%$')}>
						<CheckIcon checked={params.email === '$%_email%$'} />
						이메일 주소 자동 입력
					</button>
					<button onClick={() => onToggleParam('name', '$%name%$')}>
						<CheckIcon checked={params.name === '$%name%$'} />
						이름 자동 입력
					</button>
				</div>
			</FieldSection>

			<ToggleField
				label="기타 설정"
			>
				<>
					<FieldSection
						labelName="추천인"
						fullWidth={true}
						labelSize={''}
					>
						<input
							type="text"
							value={params.contributor}
							onChange={(e) => onChangeParam(e, 'contributor')}
						/>
					</FieldSection>
					<FieldSection
						labelName="약정메모"
						fullWidth={true}
						labelSize={''}
					>
						<input
							type="text"
							value={params.promisememo}
							onChange={(e) => onChangeParam(e, 'promisememo')}
						/>
					</FieldSection>
					<FieldSection
						labelName="배경코드"
						fullWidth={true}
						labelSize={''}
					>
						<input
							type="text"
							value={params.background}
							onChange={(e) => onChangeParam(e, 'background')}
						/>
					</FieldSection>
					<FieldSection
						labelName="추가 매개변수"
						fullWidth={true}
						labelSize={''}
					>
						<input
							type="text"
							value={params.parameters}
							placeholder="예. utm_medium=email&..."
							onChange={(e) => onChangeParam(e, 'parameters')}
						/>
					</FieldSection>
				</>
			</ToggleField>

			<FieldSection
				labelName=""
				label={false}
				fullWidth={true}
			>
				<div className="donation-link-field">
					<a href={value} target="_blank">
						결제 페이지 미리보기
						<img src={newWindowIcon} alt="link" width="11" />
					</a>
				</div>
			</FieldSection>
		</>
	);
}

export default SelectedContentDonationProduct;